import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { youthReducer } from 'src/features/atoms/glove/japan/slice/youth' // ここを Youth mitt reducerに変更
import { State, PartialAction } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { atomsYouthBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { atomsYouthFilterLogic } from 'src/features/atoms/glove/logic'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'

const YouthMittPage: React.FC = () => {
  const { t } = useLocale()
  const [state, dispatch] = React.useReducer(youthReducer, t.INITIAL_STATE_YOUTH) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  const models = atomsYouthBaseModel(t, 'mitt')

  return (
    <OrderPageTemplate breadcrumbTrail={`${t.HARD} / ATOMS / 少年用`} brand={'atoms'} {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}>
      <BaseModelSelector {...{ state, models, dispatch }} filterLogic={atomsYouthFilterLogic} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}
export default YouthMittPage
